import sodium from "libsodium-wrappers-sumo";

export interface X3DHParams {
  myIdentityPrivate: Uint8Array; // Ed25519 private key (64 bytes)
  myEphemeralPrivate: Uint8Array; // X25519 private key (32 bytes)
  theirIdentityPublic: Uint8Array; // Ed25519 public key (32 bytes)
  theirEphemeralPublic: Uint8Array; // X25519 public key (32 bytes)
  isInitiator: boolean;
}

function ed25519PrivateToX25519(edPrivate: Uint8Array): Uint8Array {
  return sodium.crypto_sign_ed25519_sk_to_curve25519(edPrivate);
}

function ed25519PublicToX25519(edPublic: Uint8Array): Uint8Array {
  return sodium.crypto_sign_ed25519_pk_to_curve25519(edPublic);
}

export function performX3DH(params: X3DHParams): Uint8Array {
  const myIdentityX = ed25519PrivateToX25519(params.myIdentityPrivate);
  const theirIdentityX = ed25519PublicToX25519(params.theirIdentityPublic);

  // DH1: my identity x their ephemeral
  const dh1 = sodium.crypto_scalarmult(myIdentityX, params.theirEphemeralPublic);
  // DH2: my ephemeral x their identity
  const dh2 = sodium.crypto_scalarmult(params.myEphemeralPrivate, theirIdentityX);
  // DH3: my ephemeral x their ephemeral
  const dh3 = sodium.crypto_scalarmult(
    params.myEphemeralPrivate,
    params.theirEphemeralPublic,
  );

  // Concatenate DH results - order swapped by role so both sides get same result
  let combined: Uint8Array;
  if (params.isInitiator) {
    combined = new Uint8Array([...dh1, ...dh2, ...dh3]);
  } else {
    combined = new Uint8Array([...dh2, ...dh1, ...dh3]);
  }

  // KDF to derive 32-byte shared secret
  return sodium.crypto_generichash(32, combined);
}
